import React from "react";
import clsx from "clsx";
import { useLocation } from "react-router-dom";

import { ILesson } from "../../state";
import { renderIconByIndex } from "../../libs/Util";
import Button from "../../atoms/Button";
import { ReactComponent as IconInfo } from "../../assets/svg/info.svg";
import { TEACHER_SESSION_KEY } from "../../Definition";

import styles from "./LessonBrief.module.scss";

export type Props = {
  lesson: ILesson;
  handleOpenGuideline: () => void;
  handleOpenMaterial: () => void;
  material_id: number;
};

const LessonBrief: React.FC<Props> = ({
  lesson,
  handleOpenGuideline,
  handleOpenMaterial,
  material_id,
}) => {
  const handleOpenRetrospective = (url: string) => {
    window.open(url, "_blank");
  };
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const classListValue = queryParams.get("classList");

  const classListValues = React.useMemo(() => {
    return classListValue
      ? classListValue.split(",").map(value => value.trim())
      : [];
  }, [classListValue]);

  const targetClassIdsSet = React.useMemo(() => {
    return new Set(classListValues.map(Number));
  }, [classListValues]);

  const hasEnoughAnswers = React.useMemo(() => {
    return lesson.answer_statuses.some(
      status =>
        targetClassIdsSet.has(status.klass_id) && status.has_enough_answers,
    );
  }, [lesson.answer_statuses, targetClassIdsSet]);

  const extra = sessionStorage.getItem(TEACHER_SESSION_KEY)
    ? `&session_id=${sessionStorage.getItem(TEACHER_SESSION_KEY)}`
    : "";

  return (
    <div className={styles.wrapper}>
      {typeof lesson.skill_no === "number" && (
        <div className={styles.skillNo}>
          {renderIconByIndex(lesson.skill_no)}
        </div>
      )}
      <div className={styles.lessonName}>{lesson.name}</div>
      <div className={styles.lessonTitleArea}>
        <p className={styles.lessonTitle}> {lesson.title}</p>
        {!lesson.published && !lesson.teacher_only && (
          <p className={styles.message}>【生徒に未開放です】</p>
        )}
      </div>

      <div className={styles.btnsArea}>
        <div className={styles.leftArea}>
          {lesson.skill_no != null && (
            <Button
              className={clsx(
                styles.materialButton,
                hasEnoughAnswers && lesson.published
                  ? styles.highlight
                  : styles.disabled,
              )}
              name="注目回答"
              variant="normal"
              disabled={!hasEnoughAnswers || !lesson.published}
              onClick={() =>
                handleOpenRetrospective(
                  `${process.env.REACT_APP_ONE_MENU_URL}/class_retrospect/${classListValues[0]}?teaching_material_id=${material_id}&lesson_id=${lesson.id}${extra}`,
                )
              }
            >
              <IconInfo className={styles.info} />
            </Button>
          )}
        </div>
        <div className={styles.rightArea}>
          <Button
            className={clsx(styles.materialButton, styles.guidance)}
            name="指導書"
            variant="normal"
            onClick={() => handleOpenGuideline()}
          />
          <Button
            className={clsx(
              styles.materialButton,
              styles.projection,
              lesson.teacher_only && styles.invisible,
            )}
            name="投影画面"
            variant="outline"
            onClick={() => handleOpenMaterial()}
          />
        </div>
      </div>
    </div>
  );
};

export default LessonBrief;
